/**
 * Check if the input is a valid JSON object
 * https://stackoverflow.com/a/33369954
 *
 * @param input - The input to check
 */
const isJson = (input: unknown) => {
  const value = typeof input !== 'string' ? JSON.stringify(input) : input;

  let parseResult: unknown;

  try {
    parseResult = JSON.parse(value) as object;
  } catch (e) {
    return false;
  }

  return typeof parseResult === 'object' && parseResult !== null;
};

export default isJson;
